import MUIBreadcrumbs from '@mui/material/Breadcrumbs';
import { styled } from '@mui/material/styles';

const Breadcrumbs = styled(MUIBreadcrumbs)(({ theme }) => ({
  '& .MuiButton-root': {
    padding: theme.spacing(1, 0.5),
    height: 'auto'
  }
}));

export default Breadcrumbs;
